// A player's notebook at a table (issue 1166; binding decision 10's named exception to the roll log; decision D on
// #1062): pages of plain text kept by their author, each private until its author shares it with the DM. Nothing here
// is a table's state, an event or a projection: the pages live in `vtt.notebook_page` and are read over HTTP only. The
// parser both sides run: what a page may hold, and what a write may change.
export const NOTEBOOK_LIMITS = { title: 120, body: 20_000, pages: 200, position: 100_000 };
/** Server → the DM's sockets only: a player's shared pages changed. Content-free; the DM's view reads them again. */
export const TABLE_NOTEBOOK = 'table:notebook';
const isObj = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);
/** One line: no control character. */
const LINE_BAD = /[\u0000-\u001f\u007f]/;
/** Paragraphs: line breaks and tabs, nothing else below space, never NUL. */
const TEXT_BAD = /[\u0000-\u0008\u000b-\u001f\u007f]/;
const KEYS = ['title', 'body', 'shared', 'position'];
/** A page's title: one line, 1–120 characters once trimmed; null when it is not one. */
export function notebookTitle(v) {
    if (typeof v !== 'string' || LINE_BAD.test(v))
        return null;
    const s = v.trim();
    return s.length >= 1 && s.length <= NOTEBOOK_LIMITS.title ? s : null;
}
/** A page's body: plain text up to 20,000 characters (Windows line ends read as one); null when it is not. */
export function notebookBody(v) {
    if (typeof v !== 'string')
        return null;
    const s = v.replace(/\r\n?/g, '\n');
    return s.length <= NOTEBOOK_LIMITS.body && !TEXT_BAD.test(s) ? s : null;
}
/** A write's fields, each checked; null when any is wrong, an unknown key is present, or nothing is set. */
export function parseNotebookPatch(v) {
    if (!isObj(v))
        return null;
    const keys = Object.keys(v);
    if (!keys.length || keys.some((k) => !KEYS.includes(k)))
        return null;
    const out = {};
    if ('title' in v) {
        const t = notebookTitle(v.title);
        if (t === null)
            return null;
        out.title = t;
    }
    if ('body' in v) {
        const b = notebookBody(v.body);
        if (b === null)
            return null;
        out.body = b;
    }
    if ('shared' in v) {
        if (typeof v.shared !== 'boolean')
            return null;
        out.shared = v.shared;
    }
    if ('position' in v) {
        if (typeof v.position !== 'number' || !Number.isInteger(v.position) || v.position < 0 || v.position > NOTEBOOK_LIMITS.position)
            return null;
        out.position = v.position;
    }
    return out;
}
/** A new page: a title is required, the rest as a write. */
export function parseNewNotebookPage(v) {
    const p = parseNotebookPatch(v);
    return p && p.title !== undefined ? p : null;
}
//# sourceMappingURL=notebook.js.map